import version from '../version'

const esc = encodeURIComponent

const client = (url, { body, ...customConfig } = {}) => {
  const headers = { 'content-type': 'application/json' }
  const config = {
    method: body ? 'POST' : 'GET',
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers,
      'RDV-Widget-Version': version,
      'RDV-Origin-FullURL': window.location.href
    }
  }
  if (body) {
    config.body = JSON.stringify(body)
  }
  if (customConfig.params) {
    const query = Object.keys(customConfig.params)
      .map(k => `${esc(k)}=${esc(customConfig.params[k])}`)
      .join('&')
    url = url + '?' + query
  }
  return fetch(url, config).then(res => {
    return res.json().then(data => {
      if (res.ok) {
        return data
      } else {
        return Promise.reject(data)
      }
    })
  })
}

export default client
